// @flow

import type { AuthBloc } from "../../blocs/authBloc";
import { apiAxios } from "../../config/AxiosConfig";

class SearchHistoryApi {
  authBloc: AuthBloc;

  constructor(authBloc: AuthBloc) {
    this.authBloc = authBloc;
  }

  async getHistory(): Promise<Array<any>> {
    const tenantId = this.authBloc.getCurrentTenant();

    const response = await apiAxios.get(
      `/tenants/${tenantId}/search-history`,
      this.buildHeaders()
    );

    if (response.status === 200) {
      return response.data || [];
    } else {
      throw new Error(response.status);
    }
  }

  async addSearch(searchTerm: string): Promise<Array<any>> {
    const tenantId = this.authBloc.getCurrentTenant();

    const response = await apiAxios.post(
      `/tenants/${tenantId}/search-history`,
      { searchTerm },
      this.buildHeaders()
    );

    if (response.status === 200 || response.status === 201) {
      return response.data || [];
    } else {
      throw new Error(response.status);
    }
  }

  buildHeaders = () => {
    const accessToken = this.authBloc.getCurrentToken();
    const auth = "Bearer " + accessToken;
    return { headers: { Authorization: auth } };
  };
}

export default SearchHistoryApi;
